import { useState } from 'react'
import { apiFetch } from '../../api/client'
import { useActionToast } from '../../lib/useActionToast'
import { actionErrorMessage } from '../../lib/actionErrorMessage'

export default function SorenFeedbackSheet({
  source,
  weekStart,
  onClose,
}: {
  source?: string | null
  weekStart?: string | null
  onClose: () => void
}) {
  const [message, setMessage] = useState('')
  const [busy, setBusy] = useState(false)
  const { showToast, Toast } = useActionToast()

  async function submit() {
    if (!message.trim()) {
      showToast('Tell Soren what to improve')
      return
    }
    setBusy(true)
    try {
      const pageContext = JSON.stringify({
        source: source || 'weekly_email',
        week_start: weekStart || null,
      })
      await apiFetch('POST', '/api/feedback', {
        category: 'idea',
        message: message.trim(),
        page_context: pageContext,
      })
      showToast('Thanks — feedback sent')
      onClose()
    } catch (e) {
      showToast(actionErrorMessage(e, 'Could not send feedback'))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="soren-feedback-sheet" data-testid="soren-feedback-sheet">
      <h3 style={{ margin: '0 0 4px', fontSize: 16, fontWeight: 600 }}>Tell Soren</h3>
      <p style={{ margin: '0 0 12px', fontSize: 13, color: 'var(--ink4)' }}>
        Something wrong in the email, or something you wish it showed?
      </p>
      <textarea
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        rows={5}
        data-testid="soren-feedback-message"
        placeholder="Your idea…"
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '10px 12px',
          borderRadius: 8,
          border: '1px solid var(--line)',
          fontSize: 14,
          resize: 'vertical',
        }}
      />
      <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
        <button type="button" className="btn btn-ghost" onClick={onClose} disabled={busy}>
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => void submit()}
          disabled={busy}
          data-testid="soren-feedback-send"
        >
          Send
        </button>
      </div>
      {Toast}
    </div>
  )
}
